export enum RolePolicySubjectEnum{
    PLAYER = 'Player',
    TEAM = 'Team',
    COMPETITION = 'Competition',
    REFEREE = 'Referee',
    STADIUM = 'Stadium',
    USER = 'User',
    MATCH = 'Match',
    ORGANIZER = 'Organizer',
    ALL = 'all',
}